
import React from 'react';
import { SubscriptionTestPanel } from '@/components/debug/SubscriptionTestPanel';
import { PaymentTestGuide } from '@/components/debug/PaymentTestGuide';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { shouldShowDebugFeatures } from '@/lib/environment';
import { Navigate } from 'react-router-dom';

const TestPayments = () => {
  // Only show in development or if debug features are enabled
  if (!shouldShowDebugFeatures()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">
            Payment Flow Testing
          </h1>
          <p className="text-muted-foreground">
            Comprehensive testing tools for the subscription and payment system
          </p>
        </div>

        <Tabs defaultValue="test-panel" className="space-y-6">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="test-panel">Test Panel</TabsTrigger>
            <TabsTrigger value="guide">Testing Guide</TabsTrigger>
          </TabsList>
          
          <TabsContent value="test-panel">
            <SubscriptionTestPanel />
          </TabsContent>
          
          <TabsContent value="guide">
            <PaymentTestGuide />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default TestPayments;
